var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74601 0.373353L5.05268 4.06669C4.80602 4.31335 4.66602 4.65335 4.66602 5.00669V11.6667C4.66602 12.4 5.26602 13 5.99935 13H11.9993C12.5327 13 13.0127 12.68 13.226 12.1934L15.3993 7.12002C15.9593 5.80002 14.9927 4.33335 13.5593 4.33335H9.79268L10.426 1.28002C10.4927 0.946687 10.3927 0.606687 10.1527 0.366687C9.75935 -0.01998 9.13268 -0.01998 8.74601 0.373353ZM1.99935 13C2.73268 13 3.33268 12.4 3.33268 11.6667V6.33335C3.33268 5.60002 2.73268 5.00002 1.99935 5.00002C1.26602 5.00002 0.666016 5.60002 0.666016 6.33335V11.6667C0.666016 12.4 1.26602 13 1.99935 13Z",
    fill: "#009B94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.34077faaf88782f798069832a1d9670f.svg";
export { ForwardRef as ReactComponent };